/**
 * TikTok Pixel injector + helpers.
 * - Call `ensureTikTokPixel(pixelId)` once config loads (idempotent).
 * - Call `tiktokTrack(event, params)` anywhere to fire a conversion event.
 */

const SCRIPT_ID = "ttq-pixel-sdk";

export function ensureTikTokPixel(pixelId) {
  if (typeof window === "undefined" || !pixelId) return;
  if (window.__ttqPixelId === pixelId) return; // already loaded with same ID
  if (window.__ttqPixelId && window.__ttqPixelId !== pixelId) {
    // Different ID switched — hard reload required; just no-op (admin change).
    return;
  }
  window.__ttqPixelId = pixelId;

  // Official TikTok Pixel bootstrap, parameterised by pixelId.
  /* eslint-disable */
  !(function (w, d, t) {
    w.TiktokAnalyticsObject = t;
    var ttq = (w[t] = w[t] || []);
    ttq.methods = [
      "page","track","identify","instances","debug","on","off","once","ready",
      "alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent",
    ];
    ttq.setAndDefer = function (t, e) {
      t[e] = function () {
        t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
      };
    };
    for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
    ttq.instance = function (t) {
      var e = ttq._i[t] || [];
      for (var n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(e, ttq.methods[n]);
      return e;
    };
    ttq.load = function (e, n) {
      var r = "https://analytics.tiktok.com/i18n/pixel/events.js";
      var o = n && n.partner;
      ttq._i = ttq._i || {};
      ttq._i[e] = [];
      ttq._i[e]._u = r;
      ttq._t = ttq._t || {};
      ttq._t[e] = +new Date();
      ttq._o = ttq._o || {};
      ttq._o[e] = n || {};
      var s = document.createElement("script");
      s.type = "text/javascript";
      s.async = true;
      s.id = SCRIPT_ID;
      s.src = r + "?sdkid=" + e + "&lib=" + t;
      var a = document.getElementsByTagName("script")[0];
      a.parentNode.insertBefore(s, a);
    };
    ttq.load(pixelId);
    ttq.page();
  })(window, document, "ttq");
  /* eslint-enable */
}

export function tiktokTrack(event, params) {
  try {
    if (typeof window === "undefined") return;
    if (!window.ttq || !window.__ttqPixelId) return;
    if (params) {
      window.ttq.track(event, params);
    } else {
      window.ttq.track(event);
    }
  } catch (e) {
    // swallow — never let analytics break UX
  }
}
